import React from "react";
import { Button } from "antd";
import styles from "./summaryButtons.scss";
import { getIconUrl } from "../../../../../services/asset";
import { SocialMediaLinks } from "../../../SocialMediaLinks/SocialMediaLinks";

export interface SummaryButtonsProps {
  hasPhones: boolean;
  onCallPhoneClick: () => void;
  onChatClick: () => void;
  seller: any;
  adId?: string;
  adTitle?: string;
  user: any;
}
function SummaryButtons(props: SummaryButtonsProps) {
  const {
    hasPhones,
    onCallPhoneClick,
    seller,
    onChatClick,
    user,
  } = props;

  const shouldShowSendMessageButton = user ? seller.id !== user.userId : true

  return (
    <div className={styles.contactButtons}>
      <SocialMediaLinks seller={seller} />
      {seller && seller.isVerified && (
        <div className={styles.verfiedNumbers}>
          <img
            className={styles.verifyBadge}
            src={getIconUrl("verified.svg")}
            alt="verified-badge"
          />
          <p className={styles.info}>{"Verificiran broj telefona"}</p>
        </div>
      )}

      {hasPhones && (
        <Button
          onClick={onCallPhoneClick}
          type="primary"
          className={`${styles.button} ${styles.phoneNumber}`}
        >
          {"Nazovite"}
        </Button>
      )}

      {shouldShowSendMessageButton && <Button
        className={`${styles.button} ${styles.email} ${!hasPhones ? styles.fullWidth : ""
          }`}
        onClick={onChatClick}
      >
        Pošalji poruku
      </Button>}
      {seller && seller.replyStatisticsMessage && (
        <p className={styles.replyStatistics}>{seller.replyStatisticsMessage}</p>
      )}
    </div>
  );
}

SummaryButtons.defaultProps = {
  hasPhones: false,
  onCallPhoneClick: () => null,
};

export default SummaryButtons;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageMobile/SummarySection/SummaryButtons/index.tsx